<p-toast></p-toast>

<div class="grid mx-3">
  <div class="col-12 md:col-6">
    <p><b class="h4">Thank you note</b></p>
    <p *ngIf="notes?.isThankYouNoteSent; else notSent">Sent {{ notes?.thankYouNoteSentDate | date }}</p>
    <ng-template #notSent><p>Thank you note not sent.</p></ng-template>

    <rc-generic-button label="Enter Sent Date"
                       iconImg="plus"
                       borderStyle="text-only"
                       level="secondary"
                       size="small"
                       (click)="onOpenThankYouDialog()"
                       [disabled]="isReadOnlyMode" />
  </div>

  <div class="col-12 md:col-6">
    <p><b class="h4">Custom note</b></p>
    <p *ngIf="notes?.customNote; else noNote">{{ notes?.customNote }}</p>
    <ng-template #noNote><p>No custom note entered.</p></ng-template>

    <rc-generic-button label="Add Custom Note"
                       iconImg="plus"
                       borderStyle="text-only"
                       level="secondary"
                       size="small"
                       (click)="onOpenCustomNoteDialog()"
                       [disabled]="isReadOnlyMode" />
  </div>
</div>

<!-- Add Custom Note MODAL -->
<div id="add-custom-note-card" data-cy="add-custom-note-card">
  <p-dialog header="Add Custom Note"
            [modal]="true"
            [(visible)]="customNoteDialogVisible"
            styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

    <div>
      <div class="formgrid">
        <div class="field">
          <label for="noteText" class="field-label required">Custom Note Text</label>
          <textarea id="customNoteText" rows="7" pInputTextarea [(ngModel)]="customNoteText" [disabled]="isReadOnlyMode"></textarea>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button 
        label="Cancel" 
        [text]="true" 
        (onClick)="onCancelCustomNote()" />
      <p-button 
        label="Save" 
        (onClick)="saveCustomNote()" 
        [disabled]="isReadOnlyMode" />
    </ng-template>

  </p-dialog>
</div>

<!-- Thank You Note MODAL -->
<div id="thank-you-note-card" data-cy="thank-you-note-card">
  <p-dialog header="Thank You Note"
            [modal]="true"
            [(visible)]="thankYouNoteDialogVisible"
            styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">

    <div>
      <div class="formgrid">
        <div class="field flex align-items-center justify-content-start">
          <p-inputSwitch id="noteSent" [(ngModel)]="isThankYouNoteSent" (onChange)="onToggleThankYouNote($event)" [disabled]="isReadOnlyMode"></p-inputSwitch>
          <label for="noteSent" class="field-label ml-2">Note Sent</label>
        </div>
        <div class="field">
          <label for="noteSendDate" class="field-label required">Sent Date</label>
          <p-calendar id="noteSendDate" [showIcon]="true" [iconDisplay]="'input'" [(ngModel)]="thankYouNoteSentDate" [disabled]="!isThankYouNoteSent || isReadOnlyMode" placeholder="MM/DD/YYYY">
          </p-calendar>
          <small *ngIf="showThankYouNoteSentDateError" class="p-error">
            Sent date is required when note is sent.
          </small>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button label="Cancel"
                [text]="true"
                (onClick)="onCancelThankyouNote()" />
      <p-button label="Save"
                (onClick)="saveThankYouNote()"
                [disabled]="isReadOnlyMode" />
    </ng-template>

  </p-dialog>
</div>
